module.exports = __webpack_public_path__ + "static/media/blog-4.a20e01bc.jpg";